import React, { Component } from 'react'
import { Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getSiteWorkData = job => {
    let manufacturingsList = []
    job.manufacturings.forEach(item => {
      manufacturingsList.push(
        <div>
          {job.manufacturings.length > 1 && <h6 className="marginTop20">{item.name}</h6>}
          <div className="row" key={item.id}>
            {item.release_for_manufacturing_date &&
              this.checkedDateListContains('Release For Manufacturing') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Release For Manufacturing</p>
                  <p>{moment(item.release_for_manufacturing_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.requested_shipment_date &&
              this.checkedDateListContains('Requested Shipment') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Requested Shipment</p>
                  <p>{moment(item.requested_shipment_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.estimated_shipment_date &&
              this.checkedDateListContains('Estimated Shipment') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Estimated Shipment</p>
                  <p>{moment(item.estimated_shipment_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.confirmed_shipment_date &&
              this.checkedDateListContains('Confirmed Shipment') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Confirmed Shipment</p>
                  <p>{moment(item.confirmed_shipment_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.estimated_delivery_date &&
              this.checkedDateListContains('Estimated Delivery') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Estimated Delivery</p>
                  <p>{moment(item.estimated_delivery_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.final_inspection_start_date &&
              this.checkedDateListContains('Final Inspection') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Final Inspection</p>
                  <p>{moment(item.final_inspection_start_date).format('YYYY-M-D')}</p>
                </div>
              )}
            {item.confirmed_delivery_date &&
              this.checkedDateListContains('Confirmed Delivery') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Confirmed Delivery</p>
                  <p>{moment(item.confirmed_delivery_date).format('YYYY-M-D')}</p>
                </div>
              )}
          </div>
        </div>
      )
    })
    return manufacturingsList
  }

  checkedDateListContains = text => {
    const { checkedDateList } = this.props
    if (checkedDateList.length == 0) {
      return true
    }
    return checkedDateList.indexOf(text) >= 0
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      if (item.manufacturings && item.manufacturings.length > 0) {
        jobList.push(
          <div>
            <h5 className="steps">{item.job_name}</h5>
            {this.getSiteWorkData(item)}
          </div>
        )
      }
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Manufacturing Schedules</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/manufacturing-schedule/ListItem.js